  (function () {
    'use strict';

    const header = document.querySelector('[data-header]');

    function updateMegamenuTop() {
      if (!header) return;

      const headerSection = header.closest('[id^="shopify-section-"]') || header.parentElement;
      let offsetAbove = 0;
      let sibling = headerSection.previousElementSibling;

      const siblingHeights = [];
      while (sibling) {
        const pos = getComputedStyle(sibling).position;
        if (pos !== 'fixed' && pos !== 'absolute') {
          siblingHeights.push(sibling.getBoundingClientRect().height);
        }
        sibling = sibling.previousElementSibling;
      }

      const headerHeight = header.getBoundingClientRect().height;
      offsetAbove = siblingHeights.reduce((sum, h) => sum + h, 0);
      document.documentElement.style.setProperty('--top-section-height', offsetAbove + 'px');

      const megamenuTop = header.classList.contains('is-fixed')
        ? headerHeight
        : offsetAbove + headerHeight;

      document.documentElement.style.setProperty('--megamenu-top', megamenuTop + 'px');
    }

    if (header) {
      let isFixed = false;

      const onScroll = function () {
        const scrollY = window.scrollY;

        if (scrollY > 100) {
          if (!isFixed) {
            isFixed = true;
            header.classList.add('is-fixed');
            updateMegamenuTop();
          }
        } else {
          if (isFixed) {
            isFixed = false;
            header.classList.remove('is-fixed');
            updateMegamenuTop();
          }
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', updateMegamenuTop, { passive: true });
      updateMegamenuTop();
      onScroll();
    }

    const navOverlay = document.getElementById('nav-overlay');

    function showOverlay() {
      if (navOverlay) navOverlay.classList.add('is-active');
    }

    function hideOverlay() {
      if (navOverlay) navOverlay.classList.remove('is-active');
    }

    document.querySelectorAll('.nav__item--has-dropdown, .nav__item--mega').forEach(function (item) {
      item.addEventListener('mouseenter', showOverlay);
      item.addEventListener('mouseleave', hideOverlay);
      item.addEventListener('focusin', showOverlay);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) hideOverlay();
      });
    });

    if (navOverlay) {
      navOverlay.addEventListener('click', function () {
        hideOverlay();
        document.querySelectorAll('.nav__link[aria-expanded="true"]').forEach(function (link) {
          link.setAttribute('aria-expanded', 'false');
        });
      });
    }

    const mobileMenu = document.querySelector('[data-mobile-navigation]');
    const hamburger = document.querySelector('[data-hamburger]');
    const mobileClose = document.querySelector('[data-mobile-close]');
    const mobileOverlay = document.querySelector('[data-mobile-overlay]');

    let mobileFocusable = [];
    let triggerBeforeOpen = null;

    function cacheMobileFocusable() {
      if (!mobileMenu) return;
      mobileFocusable = Array.from(
        mobileMenu.querySelectorAll(
          'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (el) {
        return !el.closest('[hidden]');
      });
    }

    function openMobile() {
      if (!mobileMenu) return;
      triggerBeforeOpen = document.activeElement;
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      if (hamburger) {
        hamburger.setAttribute('aria-expanded', 'true');
        hamburger.classList.add('is-open');
      }
      document.body.style.overflow = 'hidden';

      setTimeout(function () {
        cacheMobileFocusable();
        if (mobileClose) mobileClose.focus();
      }, 50);
    }

    function closeMobile() {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      if (hamburger) {
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.classList.remove('is-open');
      }
      
      document.body.style.overflow = '';

      if (triggerBeforeOpen) {
        triggerBeforeOpen.focus();
        triggerBeforeOpen = null;
      }
    }

    if (hamburger) hamburger.addEventListener('click', openMobile);
    if (mobileClose) mobileClose.addEventListener('click', closeMobile);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobile);
    if (mobileMenu) {
      mobileMenu.querySelectorAll('[data-mobile-drawer-action]').forEach(function (action) {
        action.addEventListener('click', closeMobile);
      });
    }

    const mobileDrawer = document.querySelector('.mobile-menu__drawer');
    if (mobileDrawer) {
      mobileDrawer.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    if (mobileMenu) {
      mobileMenu.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeMobile();
          return;
        }
        if (e.key !== 'Tab' || !mobileFocusable.length) return;
        const first = mobileFocusable[0];
        const last = mobileFocusable[mobileFocusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      });
    }

    function initAccordions(root) {
      root.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) {
        if (btn.dataset.accordionInit) return;
        btn.dataset.accordionInit = '1';

        const panel = btn.nextElementSibling;
        if (!panel) return;

        let cleanup = null;

        btn.addEventListener('click', function () {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          if (cleanup) {
            panel.removeEventListener('transitionend', cleanup);
            cleanup = null;
          }

          panel.style.transition = '';
          panel.style.height = panel.offsetHeight + 'px';
          panel.hidden = false;
          btn.setAttribute('aria-expanded', String(!expanded));

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              panel.style.transition = 'height .3s ease';
              if (expanded) {
                panel.style.height = '0px';
                cleanup = function () {
                  panel.style.height = panel.style.transition = '';
                  panel.hidden = true;
                  cleanup = null;
                  cacheMobileFocusable();
                };
              } else {
                panel.style.height = panel.scrollHeight + 'px';
                cleanup = function () {
                  panel.style.height = panel.style.transition = '';
                  cleanup = null;
                  cacheMobileFocusable();
                };
              }
              panel.addEventListener('transitionend', cleanup, { once: true });
            });
          });
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initAccordions(document);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      hideOverlay();
      document.querySelectorAll('.nav__link[aria-expanded="true"]').forEach(function (link) {
        link.setAttribute('aria-expanded', 'false');
      });
    });
  })();
